import { ITeam } from "@gtmhub/teams";

export function getAllTeamMembersIncludingManager(team: ITeam): string[] {
  const allTeamMembers = new Set<string>();

  if (team.members) {
    team.members.forEach((item) => allTeamMembers.add(item));
  }

  if (team.manager) {
    allTeamMembers.add(team.manager);
  }

  return Array.from(allTeamMembers);
}
